"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchWithError = fetchWithError;
exports.loadPilets = loadPilets;
exports.loadCurrentUser = loadCurrentUser;
exports.login = login;
exports.logout = logout;
async function fetchWithError(input, init) {
    const response = await fetch(input, init);
    if (!response.ok) {
        throw new Error(`An HTTP request failed with status code: ${response.status}.`);
    }
    return response;
}
async function loadPilets() {
    try {
        const response = await fetchWithError('/api/v1/pilets', { method: 'GET' });
        return await response.json();
    }
    catch (_a) {
        return [];
    }
}
async function loadCurrentUser() {
    try {
        const response = await fetchWithError('/api/v1/user', { method: 'GET' });
        return await response.json();
    }
    catch (_a) {
        return undefined;
    }
}
function login(provider) {
    location.href = `/login/${provider}?returnUrl=${encodeURIComponent(location.href)}`;
}
function logout() {
    const form = document.createElement('form');
    form.action = `/logout?returnUrl=${encodeURIComponent(location.href)}`;
    form.method = 'POST';
    form.enctype = 'text/plain';
    document.body.appendChild(form);
    form.submit();
}
